import { render, staticRenderFns } from "./NewReporte.vue?vue&type=template&id=5991c605"
import script from "./NewReporte.vue?vue&type=script&lang=js"
export * from "./NewReporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports